import { CardType } from '../db/indexedDb';

/**
 * SRS 系统的默认配置值
 */

// 每种卡片的预估学习时间（分钟）
export const DEFAULT_TIME_ESTIMATES: Record<CardType, number> = {
  speaking: 3,
  writing: 5,
  listening: 2,
  vocab: 1,
};

// 默认新卡片引入速率（每天）
export const DEFAULT_NEW_CARD_RATE = 10;

// 默认每日时间目标（分钟）
export const DEFAULT_DAILY_TIME_GOAL = 30;

// 默认口语 Part 比例 (part1:part2:part3)
export const DEFAULT_SPEAKING_PART_RATIO = {
  part1: 2,
  part2: 1,
  part3: 1
};

// Ease 调整范围
export const EASE_ADJUSTMENT_RANGE = {
  min: -0.5,
  max: 0.5,
  step: 0.05
};

// 新卡片速率预设选项
export const NEW_CARD_RATE_PRESETS = [
  { label: '保守 (5张/天)', value: 5 },
  { label: '平衡 (10张/天)', value: 10 },
  { label: '激进 (20张/天)', value: 20 },
];

// 计算基于时间目标的推荐卡片数
export function estimateCardsFromTime(
  timeMinutes: number,
  timeEstimates: Partial<Record<CardType, number>> = {},
  dailyLimits: Partial<Record<CardType, number>> = {}
): number {
  const estimates = { ...DEFAULT_TIME_ESTIMATES, ...timeEstimates };

  // 计算加权平均时间
  const types: CardType[] = ['speaking', 'writing', 'listening', 'vocab'];
  let totalWeight = 0;
  let weightedTime = 0;

  for (const type of types) {
    const limit = dailyLimits[type] ?? 0;
    if (limit > 0) {
      totalWeight += limit;
      weightedTime += limit * estimates[type];
    }
  }

  if (totalWeight === 0) {
    // 如果没有设置限额，使用默认平均时间
    const avgTime = Object.values(estimates).reduce((sum, t) => sum + t, 0) / types.length;
    return Math.floor(timeMinutes / avgTime);
  }

  const avgTime = weightedTime / totalWeight;
  return Math.floor(timeMinutes / avgTime);
}
